import type { BookingAction } from '@rental/domain'

/**
 * S9 (Q-62): what the person unlocked may do on one booking, as the booking's
 * own answer says it (`can`): by their role, or by a trip given to them on it.
 * A screen of one booking offers only these, and the server decides each
 * again. What is no booking's (a privacy view of the Owner's, a vehicle's
 * damages, the lists) keeps to the role.
 */
export type CanDo = (action: BookingAction) => boolean

export function canDo(actions: readonly BookingAction[]): CanDo {
  const allowed = new Set<BookingAction>(actions)
  return (action) => allowed.has(action)
}
